module.exports = __webpack_public_path__ + "img/project2_2.png.42f4b1ab.webp";